import { axiosV3 } from "../../Utils/Axios/axiosV3";

export const getContactUsItemsService = async (userToken: string) => {
  return axiosV3.get("/get-contact-list", {
    headers: { Authorization: `Bearer ${userToken}` },
  });
};
